module.exports = __webpack_public_path__ + "static/media/sign-out.ddc3a43c.svg";